import React from 'react';
import Image from 'next/image';

type Props = {
  image: string;
  height: number;
  width: number;
  alt: string;
};

export default function ImageBlock({ image, height = 800, width = 1200, alt = '' }: Props) {
  return (
    <div className="container p-12 rounded-md">
      <Image src={image} height={height} width={width} alt={alt} className="rounded-sm" />
    </div>
  );
}
